import { render, staticRenderFns } from "./JettonTabHistorySkeleton.vue?vue&type=template&id=3ef54ab0"
import script from "./JettonTabHistorySkeleton.vue?vue&type=script&lang=js"
export * from "./JettonTabHistorySkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports